import React, { useState } from 'react';
import { Calendar, Clock, ChevronLeft, Users, MapPin, Video, CheckSquare, FileText, Plus, X } from 'lucide-react';
import { Link } from 'react-router-dom';
export function AddMeeting() {
  const [selectedCommittee, setSelectedCommittee] = useState('');
  const [meetingType, setMeetingType] = useState('online');
  const [attendees, setAttendees] = useState<{
    id: number;
    name: string;
  }[]>([]);
  const [agendaItems, setAgendaItems] = useState<{
    id: number;
    title: string;
    duration: string;
    presenter: string;
  }[]>([]);
  const committees = [{
    id: 1,
    name: 'Finance Committee'
  }, {
    id: 2,
    name: 'HR Committee'
  }, {
    id: 3,
    name: 'IT Committee'
  }, {
    id: 4,
    name: 'Procurement Committee'
  }, {
    id: 5,
    name: 'Quality Assurance Committee'
  }];
  const availableUsers = [{
    id: 1,
    name: 'Mohammed Al Hashimi',
    committee: 'Finance Committee'
  }, {
    id: 2,
    name: 'Aisha Al Mansoori',
    committee: 'HR Committee'
  }, {
    id: 3,
    name: 'Omar Al Shamsi',
    committee: 'IT Committee'
  }, {
    id: 4,
    name: 'Fatima Al Zaabi',
    committee: 'Procurement Committee'
  }, {
    id: 5,
    name: 'Ahmed Al Dhaheri',
    committee: 'Quality Assurance Committee'
  }, {
    id: 6,
    name: 'Noura Al Suwaidi',
    committee: 'Finance Committee'
  }, {
    id: 7,
    name: 'Khalid Al Mazrouei',
    committee: 'HR Committee'
  }, {
    id: 8,
    name: 'Maryam Al Nuaimi',
    committee: 'IT Committee'
  }];
  const filteredUsers = selectedCommittee ? availableUsers.filter(user => user.committee === selectedCommittee) : availableUsers;
  const addAttendee = (userId: number) => {
    const user = availableUsers.find(u => u.id === userId);
    if (user && !attendees.some(a => a.id === userId)) {
      setAttendees([...attendees, {
        id: user.id,
        name: user.name
      }]);
    }
  };
  const removeAttendee = (id: number) => {
    setAttendees(attendees.filter(attendee => attendee.id !== id));
  };
  const addAgendaItem = () => {
    const newId = agendaItems.length > 0 ? Math.max(...agendaItems.map(item => item.id)) + 1 : 1;
    setAgendaItems([...agendaItems, {
      id: newId,
      title: '',
      duration: '',
      presenter: ''
    }]);
  };
  const updateAgendaItem = (id: number, field: string, value: string) => {
    setAgendaItems(agendaItems.map(item => item.id === id ? {
      ...item,
      [field]: value
    } : item));
  };
  const removeAgendaItem = (id: number) => {
    setAgendaItems(agendaItems.filter(item => item.id !== id));
  };
  return <div data-id="element-1253">
      <div className="flex items-center mb-6" data-id="element-1254">
        <Link to="/meetings" className="flex items-center text-gray-600 hover:text-gray-900 mr-4" data-id="element-1255">
          <ChevronLeft size={20} className="mr-1" data-id="element-1256" />
          Back to Meetings
        </Link>
        <h1 className="text-2xl font-bold" data-id="element-1257">Schedule New Meeting</h1>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1258">
        <form data-id="element-1259">
          <div className="space-y-6" data-id="element-1260">
            {/* Meeting Title */}
            <div data-id="element-1261">
              <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1262">
                Meeting Title <span className="text-red-500" data-id="element-1263">*</span>
              </label>
              <input type="text" id="title" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder="Enter meeting title" required data-id="element-1264" />
            </div>
            {/* Committee */}
            <div data-id="element-1265">
              <label htmlFor="committee" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1266">
                Committee <span className="text-red-500" data-id="element-1267">*</span>
              </label>
              <div className="relative" data-id="element-1268">
                <select id="committee" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 appearance-none" value={selectedCommittee} onChange={e => setSelectedCommittee(e.target.value)} required data-id="element-1269">
                  <option value="" data-id="element-1270">Select Committee</option>
                  {committees.map(committee => <option key={committee.id} value={committee.name} data-id="element-1271">
                      {committee.name}
                    </option>)}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-1272">
                  <Users size={18} className="text-gray-400" data-id="element-1273" />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1274">
              {/* Date */}
              <div data-id="element-1275">
                <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1276">
                  Date <span className="text-red-500" data-id="element-1277">*</span>
                </label>
                <div className="relative" data-id="element-1278">
                  <input type="date" id="date" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" required data-id="element-1279" />
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-1280">
                    <Calendar size={18} className="text-gray-400" data-id="element-1281" />
                  </div>
                </div>
              </div>
              {/* Time */}
              <div data-id="element-1282">
                <label htmlFor="time" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1283">
                  Time <span className="text-red-500" data-id="element-1284">*</span>
                </label>
                <div className="relative" data-id="element-1285">
                  <input type="time" id="time" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" required data-id="element-1286" />
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-1287">
                    <Clock size={18} className="text-gray-400" data-id="element-1288" />
                  </div>
                </div>
              </div>
              {/* Duration */}
              <div data-id="element-1289">
                <label htmlFor="duration" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1290">
                  Duration (minutes) <span className="text-red-500" data-id="element-1291">*</span>
                </label>
                <input type="number" id="duration" min="15" step="15" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder="60" required data-id="element-1292" />
              </div>
              {/* Meeting Type */}
              <div data-id="element-1293">
                <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1294">
                  Meeting Type <span className="text-red-500" data-id="element-1295">*</span>
                </label>
                <div className="flex space-x-4" data-id="element-1296">
                  <label className="flex items-center" data-id="element-1297">
                    <input type="radio" name="meetingType" value="online" checked={meetingType === 'online'} onChange={() => setMeetingType('online')} className="mr-2" data-id="element-1298" />
                    <Video size={18} className="mr-1 text-blue-500" data-id="element-1299" />
                    Online
                  </label>
                  <label className="flex items-center" data-id="element-1300">
                    <input type="radio" name="meetingType" value="inPerson" checked={meetingType === 'inPerson'} onChange={() => setMeetingType('inPerson')} className="mr-2" data-id="element-1301" />
                    <MapPin size={18} className="mr-1 text-red-500" data-id="element-1302" />
                    In-Person
                  </label>
                </div>
              </div>
            </div>
            {/* Location or Link based on meeting type */}
            <div data-id="element-1303">
              <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1304">
                {meetingType === 'online' ? 'Meeting Link' : 'Location'}{' '}
                <span className="text-red-500" data-id="element-1305">*</span>
              </label>
              <div className="relative" data-id="element-1306">
                <input type="text" id="location" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder={meetingType === 'online' ? 'Enter meeting link' : 'Enter meeting location'} required data-id="element-1307" />
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-1308">
                  {meetingType === 'online' ? <Video size={18} className="text-gray-400" data-id="element-1309" /> : <MapPin size={18} className="text-gray-400" data-id="element-1310" />}
                </div>
              </div>
            </div>
            {/* Description */}
            <div data-id="element-1311">
              <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1312">
                Description
              </label>
              <textarea id="description" rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder="Enter meeting description" data-id="element-1313"></textarea>
            </div>
            {/* Attendees */}
            <div data-id="element-1314">
              <h3 className="text-lg font-medium mb-3" data-id="element-1315">Attendees</h3>
              {/* Current Attendees */}
              {attendees.length > 0 && <div className="mb-4" data-id="element-1316">
                  <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-1317">
                    Selected Attendees
                  </h4>
                  <div className="flex flex-wrap gap-2" data-id="element-1318">
                    {attendees.map(attendee => <div key={attendee.id} className="flex items-center bg-gray-100 px-3 py-1 rounded-full" data-id="element-1319">
                        <span className="text-sm font-medium" data-id="element-1320">
                          {attendee.name}
                        </span>
                        <button type="button" onClick={() => removeAttendee(attendee.id)} className="ml-2 text-gray-400 hover:text-red-500" data-id="element-1321">
                          <X size={14} data-id="element-1322" />
                        </button>
                      </div>)}
                  </div>
                </div>}
              {/* Add Attendees */}
              <div className="flex items-end gap-3" data-id="element-1323">
                <div className="flex-1" data-id="element-1324">
                  <label htmlFor="attendee" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1325">
                    Add Attendee
                  </label>
                  <select id="attendee" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-1326">
                    <option value="" data-id="element-1327">Select Attendee</option>
                    {filteredUsers.filter(user => !attendees.some(a => a.id === user.id)).map(user => <option key={user.id} value={user.id} data-id="element-1328">
                          {user.name}
                        </option>)}
                  </select>
                </div>
                <button type="button" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" onClick={() => {
                const selectElement = document.getElementById('attendee') as HTMLSelectElement;
                const selectedUserId = Number(selectElement.value);
                if (selectedUserId) {
                  addAttendee(selectedUserId);
                  selectElement.value = '';
                }
              }} data-id="element-1329">
                  <Plus size={18} data-id="element-1330" />
                </button>
              </div>
            </div>
            {/* Agenda Items */}
            <div data-id="element-1331">
              <div className="flex justify-between items-center mb-3" data-id="element-1332">
                <h3 className="text-lg font-medium" data-id="element-1333">Agenda Items</h3>
                <button type="button" className="px-3 py-1 bg-orange-500 text-white text-sm rounded-md hover:bg-orange-600 transition-colors flex items-center" onClick={addAgendaItem} data-id="element-1334">
                  <Plus size={14} className="mr-1" data-id="element-1335" />
                  Add Item
                </button>
              </div>
              {agendaItems.length > 0 ? <div className="space-y-3" data-id="element-1336">
                  {agendaItems.map((item, index) => <div key={item.id} className="flex items-center gap-3 border border-gray-200 rounded-lg p-3" data-id="element-1337">
                      <div className="h-6 w-6 bg-gray-200 rounded-full flex items-center justify-center text-gray-600 font-medium" data-id="element-1338">
                        {index + 1}
                      </div>
                      <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-1339">
                        <input type="text" placeholder="Agenda item title" className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={item.title} onChange={e => updateAgendaItem(item.id, 'title', e.target.value)} data-id="element-1340" />
                        <input type="text" placeholder="Duration (e.g., 15 mins)" className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={item.duration} onChange={e => updateAgendaItem(item.id, 'duration', e.target.value)} data-id="element-1341" />
                        <input type="text" placeholder="Presenter" className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={item.presenter} onChange={e => updateAgendaItem(item.id, 'presenter', e.target.value)} data-id="element-1342" />
                      </div>
                      <button type="button" className="text-gray-400 hover:text-red-500" onClick={() => removeAgendaItem(item.id)} data-id="element-1343">
                        <X size={18} data-id="element-1344" />
                      </button>
                    </div>)}
                </div> : <div className="text-center py-6 bg-gray-50 rounded-lg border border-dashed border-gray-300" data-id="element-1345">
                  <FileText size={24} className="mx-auto text-gray-400 mb-2" data-id="element-1346" />
                  <p className="text-gray-500" data-id="element-1347">No agenda items added yet</p>
                  <button type="button" className="mt-2 px-3 py-1 bg-orange-500 text-white text-sm rounded-md hover:bg-orange-600 transition-colors" onClick={addAgendaItem} data-id="element-1348">
                    Add First Item
                  </button>
                </div>}
            </div>
            {/* Submit Buttons */}
            <div className="flex justify-end space-x-3 pt-4" data-id="element-1349">
              <Link to="/meetings" className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" data-id="element-1350">
                Cancel
              </Link>
              <button type="submit" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-1351">
                <Calendar size={18} className="inline mr-2" data-id="element-1352" />
                Schedule Meeting
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>;
}